<template>
	<div class="pb-21">
		<div class="grid grid-cols-12">
            <div class="col-span-12 mt-21 max-md:pt-1 md:mt-24 mb-12 md:mb-21">
    			<h1 class="headline-big">Nyheder<span class="font-serif"> /</span> <span class="text-gray-dark">News</span></h1>
            </div>
        </div>

        <div v-if="news">
            <template v-for="(entry, index) in news" :key="index">
                <ElementCardNews :data="entry"/>
            </template>
        </div>

        <div class="grid grid-cols-12 max-md:gap-y-21">
            <div class="col-span-12 mt-20 mb-20">
                <NuxtLink to="/archive" class="">
                    <ElementButton title="Gå til arkiv" englishTitle="Archive"/>
                </NuxtLink>
            </div>
        </div>
	</div>
</template>

<script setup>
const { $dateFormat } = useNuxtApp()
import { postListQuery } from '@/api/queries'
import { onMounted } from 'vue';
const config = useRuntimeConfig();
const route = useRoute();

const news = ref(null)

// Build the URL, with `query` and `token` params:
const query = postListQuery()
const token = route.query.token;
const getData = async () => {
    const { data: gql } = await useFetch(config.public.API, {
        params: { query, token },
    });

    // Extract the first page from the response:
    if (gql.value) {
        news.value = gql.value.data.newsEntries;

        console.log(news.value)
    }
}

await getData()

onMounted(() => {
    if (!news.value) {
        getData();
    }
})

useHead({
	title: `Sydhavn Teater — Nyheder / News`,
	meta: [
		{ hid: 'og:title', property: 'og:title', content: `Sydhavn Teater — Nyheder / News` },
	],
});
</script>

<style lang="scss" scoped>

</style>